import {
  FieldPolicy,
  FieldReadFunction,
  TypePolicy,
} from "@apollo/client/cache";
import { relayStylePagination } from "@apollo/client/utilities";

type KeyArgsFunction = FieldPolicy<any>["keyArgs"];
export type GraphQLTypename = `${string}Type`;

export const RelayKeyArgsFunction: KeyArgsFunction = (args) => {
  if (!args) return [];
  const keyArgs = Object.keys(args)
    .filter((arg) => !["before", "after"].includes(arg))
    .sort((a, b) => a.localeCompare(b));
  return keyArgs;
};

export const mergeRootQuery: TypePolicy["merge"] = (existing, incoming) => {
  if (!existing) return incoming;
  return {
    ...existing,
    ...incoming,
  };
};

export const relayNodeRead: (type_: GraphQLTypename) => FieldReadFunction =
  (type_) =>
  (_, { args, toReference }) => {
    return toReference({
      __typename: type_,
      id: args?.id,
    });
  };

export const rootQueryTypePolicy: (
  connectionFields: string[],
  relayNodeFields?: { query: string; GType: GraphQLTypename }[],
) => TypePolicy = (connectionFields, relayNodeFields = undefined) => {
  const calculatedFields: {
    [fieldName: string]: FieldPolicy<any> | FieldReadFunction<any>;
  } = connectionFields.reduce(
    (prev, field) => ({
      ...prev,
      [field]: relayStylePagination(RelayKeyArgsFunction),
    }),
    {},
  );
  const calculatedRelayNodeFields: {
    [fieldName: string]: FieldPolicy<any> | FieldReadFunction<any>;
  } =
    relayNodeFields?.reduce(
      (prev, relayField) => ({
        ...prev,
        [relayField.query]: {
          read: relayNodeRead(relayField.GType),
        },
      }),
      {},
    ) ?? {};
  return {
    keyFields: false,
    merge: mergeRootQuery,
    fields: {
      ...calculatedFields,
      ...calculatedRelayNodeFields,
    },
  };
};

export const withFields = (
  base: TypePolicy,
  extra: { [fieldName: string]: FieldPolicy<any> | FieldReadFunction<any> },
): TypePolicy => ({
  ...base,
  fields: { ...base.fields, ...extra },
});
